import {
  SET_CONTEXTUAL_SUPPORT,
  UNSET_CONTEXTUAL_SUPPORT,
  LOGOUT_COMPLETE,
  SET_CONTEXTUAL_SUPPORT_VISIBILITY,
} from '../../constants/actionTypes';

const initialState = {
  // stack of support pages. the last added page is the one shown.
  supportPageKeys: [],
  visible: false,
};

export const contextualSupportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTEXTUAL_SUPPORT:
      return setContextualSupport(state, action);

    case SET_CONTEXTUAL_SUPPORT_VISIBILITY:
      return setContextualSupportVisibility(state, action);

    case UNSET_CONTEXTUAL_SUPPORT:
      return unsetContextualSupport(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

function setContextualSupport(state, action) {
  const { supportPageKey } = action.payload;
  const { supportPageKeys } = state;

  if (
    supportPageKeys.length > 0 &&
    supportPageKeys[supportPageKeys.length - 1] === supportPageKey
  ) {
    return state;
  }

  return {
    ...state,
    supportPageKeys: [...supportPageKeys, supportPageKey],
  };
}

function setContextualSupportVisibility(state, action) {
  const { visible } = action.payload;

  return {
    ...state,
    visible,
  };
}

function unsetContextualSupport(state, action) {
  const { supportPageKey } = action.payload;
  const { supportPageKeys } = state;
  const keyIndex = supportPageKeys.indexOf(supportPageKey);

  if (keyIndex < 0) {
    return state;
  }

  // remove supportPageKey and all keys which were added after it
  return {
    ...state,
    supportPageKeys: supportPageKeys.slice(0, keyIndex),
  };
}
